import { RouterStore, syncHistoryWithStore } from '@superwf/mobx-react-router'
import { createBrowserHistory } from 'history'

const routingStore = new RouterStore()
const browsingHistory = createBrowserHistory()
const history = syncHistoryWithStore(browsingHistory, routingStore)

export { routingStore, history }
